import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { LoaderService } from "../../service/loader.service";

@Component({
  selector: "app-loader",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./loader.component.html",
  styleUrl: "./loader.component.scss",
})
export class LoaderComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;
  private fadeOutTimer?: ReturnType<typeof setTimeout>;

  /** Keeps overlay in DOM so the ring animation never restarts abruptly. */
  visible = false;
  active = false;

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.subscription = this.loaderService.isLoading.subscribe((isLoading) => {
      if (isLoading) {
        if (this.fadeOutTimer) {
          clearTimeout(this.fadeOutTimer);
          this.fadeOutTimer = undefined;
        }

        this.visible = true;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.active = true;
          });
        });
        return;
      }

      this.active = false;
      this.fadeOutTimer = setTimeout(() => {
        this.visible = false;
        this.fadeOutTimer = undefined;
      }, 320);
    });
  }

  ngOnDestroy(): void {
    if (this.fadeOutTimer) {
      clearTimeout(this.fadeOutTimer);
    }
    this.subscription.unsubscribe();
  }
}
